import React from 'react';
import { motion } from 'framer-motion';

const LogoLoader = ({ 
  size = 112, // Default size in pixels
  duration = 1.8, // Animation duration in seconds
  showBackground = true, // Whether to show the full-screen background
  className = '' // Additional className for the container
}) => {
  // Animation variants for better control
  const logoVariants = {
    initial: { 
      scale: 0.9,
      opacity: 0.8,
      rotate: 0
    },
    animate: { 
      rotate: 360,
      scale: [1, 1.15, 1],
      opacity: [0.8, 1, 0.8],
      transition: {
        duration,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  const containerClasses = `flex items-center justify-center ${showBackground ? 'h-screen bg-white z-50' : ''} ${className}`;

  return (
    <div 
      className={containerClasses}
      role="status" 
      aria-live="polite"
      aria-label="Loading content"
    >
      <motion.img
        src="/favicon.png" // Replace with your actual logo path
        alt="Loading indicator"
        className="object-contain"
        style={{ width: size, height: size }}
        initial="initial"
        animate="animate"
        variants={logoVariants}
        // Accessibility attributes
        aria-hidden="true"
        focusable="false"
      />
    </div>
  );
};

export default LogoLoader;